export enum NotificationBoxType {
	Notification = 1,
	Message = 2,
	Friend = 3,
	// is custom
	Announcement = 4
}